import { Component, ElementRef, OnInit, TemplateRef, ViewChild, OnDestroy } from '@angular/core';
import { PaginationService } from '../PaginationService';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { DynamicAuditTrailComponent } from '../support/dynamic-audit-trail/dynamic-audit-trail.component';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/core';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { EditorComponent } from '../editor/editor.component';
@Component({
  selector: 'app-foms-logs-implementation',
  templateUrl: './foms-logs-implementation.component.html',
  styleUrls: ['./foms-logs-implementation.component.scss']
})
export class FomsLogsImplementationComponent implements OnInit, OnDestroy {


  isProcessing = false;
  formName: any = "";
  searchValue: any = "";

  handleUserSearchText: string = '';
  verifierSearchText: string = '';
  templateSearchText: string = '';
  templateSearchText1: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }


  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) { }

  selectedTemplate: any = null;
  selectedTemplateMasterSearch: any = null;
  templateToAddFormDropdown: any = [];
  selectedHandleUser: any = [];
  selectedVerifyUser: any = [];
  formUsersDropdown: any = [];
  formsList: any = [];
  formsListTemplate: any = [];
  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
    closeDropDownOnSelection: true,
  };

  multipleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
  };

  @ViewChild('editFormPopup', { static: true }) editFormPopup: TemplateRef<any>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  addAndEditPopupConfig = {
    width: '900px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '60px' },
    disableClose: true,
  };

  @ViewChild('formUserPopup', { static: true }) formUserPopup: TemplateRef<any>;
  visibleFormUserPopup: MatDialogRef<TemplateRef<any>>;
  formUserPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  @ViewChild('addUserPopup', { static: true }) addUserPopup: TemplateRef<any>;
  visibleAddUserPopup: MatDialogRef<TemplateRef<any>>;
  addUserPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };
  uiDateFormat = "dd-MMM-YYYY"
  uiDateTimeFormat = "dd-MMM-YYYY HH:mm:ss"
  private clickListener: () => void;
  private boundKeyDown = this.onKeyDown.bind(this);
  private boundKeyUp = this.onKeyUp.bind(this);
  private boundReset = this.resetKeyState.bind(this);

  ngOnInit(): void {
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');

    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat
        .replaceAll("DD", 'dd')
        .replaceAll("MON", "MMM")
        .replaceAll("Y", 'y');
    } else {
      this.uiDateFormat = "dd-MMM-yyyy";
    }

    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat
        .replaceAll("DD", 'dd')
        .replaceAll("HH24:MI:SS", 'HH:mm:ss')
        .replaceAll("MON", "MMM")
        .replaceAll("Y", 'y');
    } else {
      this.uiDateTimeFormat = "dd-MMM-yyyy HH:mm:ss";
    }
    this.formsListTemplate = null;
    this.isProcessing = true;
    this.appService.getForms('Total').subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        if (this.formsListTemplate == null) {
          console.log("this.formsListTemplate====", data);
          this.formsListTemplate = Array.from(
            new Map(
              data.map((item: { templateId: any; }) => [item.templateId, item])  
            ).values()
          );
          console.log("this.formsListTemplate====", this.formsListTemplate);
        }

      }, error: (error) => {
        this.isProcessing = false;
      }
    })
    this.UiMatrixList = [];
    this.initMethod();
    this.getCall();
    document.addEventListener('keydown', this.boundKeyDown);
    document.addEventListener('keyup', this.boundKeyUp);
    window.addEventListener('blur', this.boundReset);
    document.addEventListener('contextmenu', this.boundReset);
    this.isProcessing = true;
    this.appService.getTemplatesToAddForms().subscribe({
      next: (data: any) => {
        this.isProcessing = false;
        for (const item of data) {
          this.templateToAddFormDropdown = this.templateToAddFormDropdown.concat({
            valueExp: item.templateId,
            displayExp: item.templateName
          });
        }
      }, error: (error) => {
        this.isProcessing = false;
      }
    })

    this.isProcessing = true;
    this.appService.getFormUsers().subscribe((data: any) => {
      this.isProcessing = false;
      for (const user of data) {
        this.formUsersDropdown = this.formUsersDropdown.concat({
          valueExp: user.userId,
          displayExp: user.userFullname
        });
      }
    })
  }

  rerefreshGrid() {
    this.isProcessing = true;
    if (this.selectedTemplateMasterSearch) {
      this.appService.getFormsMasterPage(this.byStatus, this.selectedTemplateMasterSearch).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.formsList = data;
          this.collectionSize = this.formsList.length;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        }, error: (error) => {
          this.isProcessing = false;
        }
      })
    }
    else {
      this.appService.getForms(this.byStatus).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.formsList = data;
          this.collectionSize = this.formsList.length;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        }, error: (error) => {
          this.isProcessing = false;
        }
      })
    }
  }


  byStatus: any = "Active";
  matrixList: any;
  totalNumberOfData: any;
  UiMatrixList: any = [];
  initMethod() {
    console.log("welcome");
    this.totalNumberOfData = null;
    this.UiMatrixList = [];
    // (Optional) clear chart or UI if needed
    this.byStatus = '';
    this.preIdAttibute = '';
    console.log("this.UiMatrixList1=", this.UiMatrixList);
    this.appService.getMatrixForForms(this.selectedTemplateMasterSearch ?? 0).subscribe((data: any) => {
      this.matrixList = data;
      let totalCount = 0;
      let completed = 0;
      let obsoleted = 0;
      let active = 0;
      for (const item of data) {
        totalCount += item.count;
        if (item.status == "Completed") {
          completed += item.count;
        } else if (item.status == "Obsoleted") {
          obsoleted += item.count;
        } else {
          active += item.count;
        }
      }
      this.appService.getMyTotal(this.selectedTemplateMasterSearch ?? 0).subscribe((data: any) => {
        this.UiMatrixList.push(
          { id: 1, status: 'Total', colorCode: '#0080FF', count: totalCount },
          { id: 2, status: 'Completed', colorCode: '#009C40', count: completed },
          { id: 3, status: 'Active', colorCode: '#ECFF00', count: active },
          { id: 4, status: 'Obsoleted', colorCode: '#FF0000', count: obsoleted },
          { id: 5, status: 'My Total', colorCode: '#FF00FB', count: data[0] }
        );
        this.totalNumberOfData = this.UiMatrixList.filter((x: any) => x.status === 'Total');
        console.log("this.UiMatrixList2=", this.UiMatrixList);
        for (const item of this.UiMatrixList) {
          if (item.status !== 'Total') {
            if (item.count && item.count > 0 && this.totalNumberOfData[0]?.count && this.totalNumberOfData[0].count > 0) {
              item.percentage = Math.round((item.count / this.totalNumberOfData[0].count) * 100);
            } else {
              item.percentage = 0;
            }
          }
          if (!item.count) {
            item.count = 0;
          }
        }

        this.UiMatrixList.sort((a: any, b: any) => a.id - b.id);

        // Initialization of Active Chart.
        setTimeout(() => this.setInitialChartActiveValue(), 1000);
      })
    })
    console.log("this.UiMatrixList3=", this.UiMatrixList);
    this.isProcessing = false;
  }

  getCallByTemplateId(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {

        console.log("item5555=", item.templateId)
        this.selectedTemplateMasterSearch = item.templateId;
        console.log("this.selectedTemplateMasterSearch===", this.selectedTemplateMasterSearch);
        this.initMethod();
        this.getCall();
      }
      else {
        this.selectedTemplateMasterSearch = null;
        this.initMethod();
        this.getCall();
      }
    }
  }

  private setInitialChartActiveValue(): void {
    this.preIdAttibute = '';
    const getInitialActiveValue = this.UiMatrixList.find((x: any) => x.status === 'Active');
    this.byStatus = getInitialActiveValue.status;
    this.onClickOnChart(getInitialActiveValue.id, getInitialActiveValue);
  }

  getCall() {
    this.isProcessing = true;
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);

    if (this.selectedTemplateMasterSearch) {
      this.appService.getFormsMasterPage(this.byStatus ?? 'Total', this.selectedTemplateMasterSearch).subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.formsList = data;
          this.collectionSize = this.formsList.length;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        }, error: (error) => {
          this.isProcessing = false;
        }
      })
    } else {
      this.appService.getForms(this.byStatus ?? 'Total').subscribe({
        next: (data: any) => {
          this.isProcessing = false;
          this.formsList = data;

          this.collectionSize = this.formsList.length;
          this.pager.totalPages = undefined;
          this.setPage(1, 0);
        }, error: (error) => {
          this.isProcessing = false;
        }
      })
    }

  }

  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.formsListTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.formsListTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.formsListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }
  htmlContent: any;
  @ViewChild(EditorComponent) editorComponent!: EditorComponent;

  getClobData1(event: Event, data: any, column: string, val: any, view: string): void {
    event.stopPropagation();

    console.log("Primary Data:", data);

    this.isProcessing = true;

    try {
      const formattedColumn = this.formatColumnName(column);
      this.htmlContent = val;

      if (this.editorComponent) {
        this.editorComponent.openEditor(this.htmlContent, formattedColumn);
      } else {
        console.error("EditorComponent is not initialized.");
      }
    } catch (error) {
      console.error("Error in getClobData1:", error);
    } finally {
      this.isProcessing = false;
    }
  }

  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }


  formsListTemp: any;
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.formsListTemp = this.formsList;
      this.pager = this.paginationService.getPager(this.formsListTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.formsListTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {

      if (this.formsList == undefined) {
        return this.formsList;
      }
      if (!this.formsList.length) {
        return this.formsList;
      }
      if (filter) {
        this.formsListTemp = this.formsList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.formsListTemp = this.formsList.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });
      }
      this.setPagedorserch(1, 0);
    }
  }

  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  perPage3 = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private readonly users: any[];
  pager: any = {};
  pager3: any = {};
  pagedItems: any[]; pagedItems1: any[];
  pagedItems2: any[];
  pagedItems3: any[];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.formsList.length, page, this.perPage, targetpage);
    this.pagedItems = this.formsList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  visibleAddButton: boolean = false;
  visibleEditButton: boolean = false;
  openAddPopup() {
    this.selectedTemplate = null;
    this.formObj = {};
    this.formObj.formName = "";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.visibleAddAndEditPopup = this.dialog.open(this.editFormPopup, this.addAndEditPopupConfig);
    this.visibleAddAndEditPopup.afterClosed().subscribe(() => {
      this.rerefreshGrid();
    });
  }

  formObj: any = {};
  editForm(form: any, event: any) {
    this.formObj = form;
    this.visibleAddButton = false;
    this.visibleEditButton = true;
    this.visibleAddAndEditPopup = this.dialog.open(this.editFormPopup, this.addAndEditPopupConfig);
    this.visibleAddAndEditPopup.afterClosed().subscribe(() => {
      this.rerefreshGrid();
    });
  }

  addFormusersFunc(form: any, event: any) {
    this.formObj = form;
    this.formObj.module = "FORMS";
    this.visibleFormUserPopup = this.dialog.open(this.formUserPopup, this.formUserPopupConfig);
  }
  limitCharacters(event: Event, field: string) {
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const textLength = target.value.length;
    let charLimit: number | null = null;

    const fieldMapping: Record<number, string[]> = {
      // 4000: [ 'FOOTER', 'FORM_DESCRIPTION']
      3050: ['FOOTER'],
      750: ['FORM_DESCRIPTION']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = +limit;
        break;
      }
    }

    if (charLimit !== null && textLength > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      const trimmedValue = target.value.substring(0, charLimit);
      target.value = trimmedValue;
      switch (field) {

        case 'FOOTER':
          this.formObj.footer = trimmedValue;
          break;
        case 'FORM_DESCRIPTION':
          this.formObj.formDescription = trimmedValue;
          break;
      }
    }
  }

  limitEditorContent(value: string, field: string) {
    let charLimit: number | null = null;

    const fieldMapping: Record<number, string[]> = {
      3050: ['HEADER']
    };

    for (const [limit, fields] of Object.entries(fieldMapping)) {
      if (fields.includes(field)) {
        charLimit = +limit;
        break;
      }
    }

    if (charLimit !== null && value.length > charLimit) {
      this.showSnackBar("Maximum " + charLimit + " Characters!", 'E');
      this.formObj.header = value.substring(0, charLimit);
    }
  }

  selectedCommonUsers: any = [];
  addedFormUSersList: any = [];
  addusersFunc(form: any, event: any) {
    this.formObj = form;
    this.formObj.module = "FORMS"
    this.selectedHandleUser = [];
    this.selectedVerifyUser = [];
    this.selectedCommonUsers = [];
    this.isProcessing = true;
    this.visibleAddUserPopup = this.dialog.open(this.addUserPopup, this.addUserPopupConfig);
  }

  template: any;
  formNamecss: any;
  templateRequiredMsg: any;
  formNamecssRequiredMsg: any;

  editFormCss: any;
  editFormCssRequiredMsg: any;
  formFieldValidation() {
    this.editFormCss = document.getElementById('formNameForEdit') as HTMLInputElement;
    this.editFormCssRequiredMsg = document.getElementById('formNameForEdit-required-msg') as HTMLInputElement;
    this.template = document.getElementById('template-select-container') as HTMLInputElement; // You need to add this ID to your HTML
    this.templateRequiredMsg = document.getElementById('template-required-msg') as HTMLInputElement;

    if (this.selectedTemplate) {
      if (this.template) this.template.style.color = 'none';
      if (this.templateRequiredMsg) this.templateRequiredMsg.style.display = 'none';
    } else {
      if (this.template) this.template.style.color = 'red';
      if (this.templateRequiredMsg) this.templateRequiredMsg.style.display = 'block';
    }

    if (this.formObj.formName == "" || this.formObj.formName == null) {
      this.editFormCss.style.color = 'red';
      this.editFormCssRequiredMsg.style.display = 'block';
    } else {
      this.editFormCss.style.color = 'none';
      this.editFormCssRequiredMsg.style.display = 'none';
    }
  }

  onFieldFocusout() {
    if (this.formNamecssRequiredMsg != undefined && this.formName != "") {
      this.formNamecss.style.border = 'none';
      this.formNamecssRequiredMsg.style.display = 'none';
    }

    if (this.templateRequiredMsg != undefined && !this.selectedTemplate) {
      this.template.style.border = 'none';
      this.templateRequiredMsg.style.display = 'none';
    }

    if (this.editFormCssRequiredMsg != undefined && this.formObj.formName != "") {
      this.editFormCss.style.border = 'none';
      this.editFormCssRequiredMsg.style.display = 'none';
    }
  }

  addFormFunc() {
    if (!this.selectedTemplate || this.formName == "") {
      this.formFieldValidation();
    } else {
      this.isProcessing = true;
      let data = {

        formName: this.formName,
        templateId: this.selectedTemplate ?? null
      }
      this.appService.addForm(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == 'S') {
            this.initMethod();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  addAndEditFunction(formObj: any) {
    if (this.visibleAddButton) {
      if (!this.selectedTemplate || this.formObj.formName == "") {
        this.formFieldValidation();
      } else {
        this.isProcessing = true;
        let data = {

          formName: this.formObj.formName,
          formDescription: this.formObj.formDescription,
          templateId: this.selectedTemplate ?? null
        }
        this.appService.addForm(data).subscribe({
          next: (Response: any) => {
            this.isProcessing = false;
            if (Response.resultType == 'S') {
              this.visibleAddAndEditPopup.close();
              this.initMethod();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    } else {
      if (this.formObj.formName == null || this.formObj.formName == "") {
        this.formFieldValidation();
      } else {
        this.isProcessing = true;
        delete this.formObj.createdOn;
        delete this.formObj.updatedOn;

        this.formObj.lockedOn = this.formObj.lockedOn ? new Date(this.formObj.lockedOn) : null
        this.formObj.lastActionOn = this.formObj.lastActionOn ? new Date(this.formObj.lastActionOn) : null
        this.appService.updateForm(this.formObj).subscribe({
          next: (Response: any) => {
            if (Response.resultType == 'S') {
              this.initMethod();
              this.visibleAddAndEditPopup.close();
            }
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: Response.result,
                type: Response.resultType == 'S' ? 'Success' : 'Error',
                buttonLabel: "Ok",
                pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
            });
            sb.onAction().subscribe(() => {
              sb.dismiss();
            });
            this.isProcessing = false;
          }, error: (error) => {
            this.isProcessing = false;
            throw error;
          }
        });
      }
    }

  }

  resetAddFormFunc() {
    this.selectedTemplate = null;
    this.formName = "";
  }

  goToDetail(form: any, event: any) {
    event.preventDefault();
    this.message.breadcrumbData.secondLevel = form.formName;
    this.message.breadcrumbData.thirdLevel = null;
    form.isFrom = "FORM"
    this.router.navigate(['/dashboard/formsAndLogsDetail'], {
      state: {
        formObj: form
      }
    });
  }

  cancelFormUserFunction() {
    this.visibleFormUserPopup.close();
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
    this.rerefreshGrid();
  }

  onHandleFormUserSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => { this.handleUserSelection = this.selectedHandleUser.length == this.formUsersDropdown.length })
    }
  }

  @ViewChild('handler') handler: MatSelect;
  handleUserSelection = false;
  @ViewChild('verifier') verifier: MatSelect;
  verifierSelection = false;

  toggleAllSelection(value: any) {
    if (value == 'handler') {
      if (this.handleUserSelection) this.handler.options.forEach((item: MatOption) => item.select());
      else {
        this.handler.options.forEach((item: MatOption) => item.deselect())
        this.selectedHandleUser = [];
      }
    } else if (value == 'verifierUser') {
      if (this.verifierSelection) this.verifier.options.forEach((item: MatOption) => item.select());
      else {
        this.verifier.options.forEach((item: MatOption) => item.deselect())
        this.selectedVerifyUser = [];
      }
    }
  }

  addUserForForm() {
    this.isProcessing = true;
    for (const handleUser of this.selectedHandleUser) {
      for (const verifyUser of this.selectedVerifyUser) {
        if (handleUser == verifyUser) {
          if (!this.selectedCommonUsers.includes(handleUser)) {
            this.selectedCommonUsers.push(handleUser);
          }
        }
      }
    }

    let data: any = {

      templateId: this.formObj.templateId,
      formId: this.formObj.formId
    }
    for (const commonUser of this.selectedCommonUsers) {
      for (let k = 0; k < this.selectedHandleUser.length; k++) {
        if (commonUser.valueExp == this.selectedHandleUser[k]) {
          this.selectedHandleUser.splice(k, 1);
          k--;
        }
      }
      for (let k = 0; k < this.selectedVerifyUser.length; k++) {
        if (commonUser.valueExp == this.selectedVerifyUser[k]) {
          this.selectedVerifyUser.splice(k, 1);
          k--;
        }
      }
      data.handleForm = "Y";
      data.verifyFormData = "Y";
      data.userId = commonUser.valueExp;
      this.commonOperation(data);
    }
    for (const handleUser of this.selectedHandleUser) {
      data.handleForm = "Y";
      data.verifyFormData = "N";
      data.userId = handleUser;
      this.commonOperation(data);
    }

    for (const verifyUser of this.selectedVerifyUser) {
      data.handleForm = "N";
      data.verifyFormData = "Y";
      data.userId = verifyUser;
      this.commonOperation(data);
    }
  }

  commonOperation(data: any) {
    let filteredData = this.addedFormUSersList.filter((user: any) => user.userId == data.userId);
    if (filteredData.length > 0) {
      this.appService.updateFormTemplateUser(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.visibleAddUserPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    } else {
      this.appService.createFormTemplateUser(data).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            this.visibleAddUserPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, error: (error) => {
          this.isProcessing = false;
          throw error;
        }
      });
    }
  }

  cancelAddUserFunc() {
    this.visibleFormUserPopup.close();
  }

  currentIdAttibute: any;
  preIdAttibute: any = '';
  styleMiniChartContainer: any;
  onClickOnChart(event: any, data: any) {
    this.isProcessing = true;
    if (this.preIdAttibute != '') {
      this.styleMiniChartContainer = document.getElementById(this.preIdAttibute) as HTMLInputElement;
      this.styleMiniChartContainer.style.boxShadow = '';
    }

    if (event.currentTarget) {
      this.currentIdAttibute = event.currentTarget.id;
      this.preIdAttibute = event.currentTarget.id;
      this.byStatus = data.status;
    } else {
      this.currentIdAttibute = "" + event + "";
      this.preIdAttibute = "" + event + "";
    }

    this.styleMiniChartContainer = document.getElementById(this.currentIdAttibute) as HTMLInputElement;
    if (this.styleMiniChartContainer != null) {
      this.styleMiniChartContainer.style.boxShadow = 'rgb(38 102 255) 0px 5px 10px';
    }


    this.getCall();
  }

  @ViewChild(DynamicAuditTrailComponent) dynamicAuditTrailComponent!: DynamicAuditTrailComponent;
  auditTrail: any = {};
  openAuditTrail(viewType: any, form: any) {
    this.auditTrail.refNo = viewType == 'overAll' ? null : form.formId;
    this.auditTrail.gridName = 'FORMS';
    this.auditTrail.report_And_Popup_Name = 'Forms Audit Trail';
    this.dynamicAuditTrailComponent.triggerTrail(form);
  }

  @ViewChild('angularEditor', { static: true }) angularEditor: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  angularEditorConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  excludeButtons: EditorConfig = {
    buttons: [],
  };

  includeButtons: EditorConfig = {
    buttons: ST_BUTTONS,
  };

  editorTitle: string = '';
  editorValue: any = null;
  openEditor(value: string) {

    const programmingCasedValue = value
      .split(' ')
      .map((word, index) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');

    [this.editorTitle, this.editorValue] = [value, this.formObj[programmingCasedValue] || ''];
    this.visibleAngularEditor = this.dialog.open(this.angularEditor, this.angularEditorConfig);
  }

  saveAngularEditor(editorValue: any) {
    const programmingCasedValue = this.editorTitle
      .split(' ')
      .map((word: string, index: number) => index === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join('');

    this.formObj[programmingCasedValue] = editorValue;
    this.visibleAngularEditor.close();
  }

  closeAngularEditor() {
    this.visibleAngularEditor.close();
  }

  ctrlPressed: boolean = false;
  shiftPressed: boolean = false;
  ngOnDestroy() {
    document.removeEventListener('keydown', this.boundKeyDown);
    document.removeEventListener('keyup', this.boundKeyUp);
    window.removeEventListener('blur', this.boundReset);
    document.removeEventListener('contextmenu', this.boundReset);
    if (this.clickListener) {
      this.clickListener();
    }
  }

  onKeyDown(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = true;
    } else if (event.key === 'Shift') {
      this.shiftPressed = true;
    }
  }

  onKeyUp(event: KeyboardEvent) {
    if (event.key === 'Control') {
      this.ctrlPressed = false;
    } else if (event.key === 'Shift') {
      this.shiftPressed = false;
    }
  }

  resetKeyState() {
    this.ctrlPressed = false;
    this.shiftPressed = false;
  }

  onPaste(event: ClipboardEvent) {
    const isAllowedPaste = this.ctrlPressed && this.shiftPressed;
    if (!isAllowedPaste) {
      event.preventDefault();
      this.showSnackBar("You can't perform this operation. Please use Ctrl + Shift + V to paste the content", 'E');
    }
  }

  showSnackBar(message: string, type: string) {
    const sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: type === 'S' ? 5000 : undefined,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Error',
        buttonLabel: 'Ok',
        pageName: this.message.breadcrumbData.thirdLevel
          ?? this.message.breadcrumbData.secondLevel
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    sb.onAction().subscribe({
      next: () => {
        sb.dismiss();
      },
      error: (error: any) => {
        this.isProcessing = false;
        throw error;
      },
      complete: () => { }
    })
  }


  parseCustomDate(dateStr: string): Date | null {
    if (!dateStr) return null;

    // Convert: 30-DEC-2025 10:55:05 → 2025-12-30T10:55:05
    const parts = dateStr.split(' ');
    const datePart = parts[0];
    const timePart = parts[1];

    const [day, mon, year] = datePart.split('-');
    const monthMap: any = {
      JAN: '01', FEB: '02', MAR: '03', APR: '04',
      MAY: '05', JUN: '06', JUL: '07', AUG: '08',
      SEP: '09', OCT: '10', NOV: '11', DEC: '12'
    };

    const isoDate = `${year}-${monthMap[mon]}-${day}T${timePart}`;
    return new Date(isoDate);
  }
}
